import React, { FC } from "react";
import Explanation from "../ProofAndExplanation/Explanation";
import Formula from "../Formula/Formula";

interface FormulaListExplanationProps {
    lines: string[];
    title: string;
}

const FormulaListExplanation: FC<FormulaListExplanationProps> = ({ lines, title }) => {
    if (!lines.length) return null;

    return (
        <Explanation text={title}>
            <div className="mt-2 flex flex-col items-start">
                {lines.map((line, idx) => (
                    <Formula formula={line} key={idx} />
                ))}
            </div>
        </Explanation>
    );
};

export default FormulaListExplanation;
